JST["quick-cart-fragment-delete-button"] = function anonymous(it
) {
var out='<button class="delete-row-btn" data-delete-row data-rowhash="'+( it.tempHash)+'"> <div class="icon-cross"></div></button>';return out;
};